<template>
  <div class="card border-0 bg-white">
    <div class="card-header">
      <h3 class="fw-semibold">Modifier la publication</h3>
    </div>

    <div class="card-body p-25">
      <Form
        :initial-values="initialValues"
        @submit="updatePublication"
        :validation-schema="publicationSchema"
        v-if="loaded"
      >
        <div class="row">

          <!-- Titre -->
          <div class="col-md-6">
            <label>Titre *</label>
            <Field name="titre" class="form-control" />
            <ErrorMessage name="titre" class="text-danger"/>
          </div>

          <!-- Auteur -->
          <div class="col-md-6">
            <label>Auteur *</label>
            <Field name="auteur" class="form-control" />
            <ErrorMessage name="auteur" class="text-danger"/>
          </div>

          <!-- Catégorie -->
          <div class="col-md-6">
            <label>Catégorie *</label>
            <Field name="categoriepublication" v-slot="{ field }">
              <Multiselect
                v-model="field.value"
                :options="categorieOptions"
              />
            </Field>
          </div>

          <!-- Année -->
          <div class="col-md-6">
            <label>Année *</label>
            <Field name="annepublication" type="number" class="form-control"/>
          </div>

          <!-- Éditeur -->
          <div class="col-md-6">
            <label>Éditeur *</label>
            <Field name="editeur" class="form-control"/>
          </div>

          <!-- Image -->
          <div class="col-md-6">
            <label>Nouvelle image (optionnel)</label>
            <input type="file" class="form-control" @change="onImageChange"/>
          </div>

          <!-- Aperçu image -->
          <div class="col-md-12 mt-3" v-if="currentImage">
            <img
              :src="getUrlApiForFiles(currentImage)"
              style="height:150px;border-radius:12px"
            />
          </div>

          <!-- Contenu -->
          <div class="col-md-12 mt-3">
            <label>Contenu</label>
            <QuillEditor
                ref="contenuEditor"
                v-model:content="contenu"
                content-type="html"
                theme="snow"
                toolbar ="full"
              />
          </div>

          <!-- Boutons -->
          <div class="col-md-12 mt-4">
            <button class="btn btn-success">Modifier</button>
            <router-link to="/listPublication" class="btn btn-danger ms-2">
              Annuler
            </router-link>
          </div>

        </div>
      </Form>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";
import { Form, Field, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import Multiselect from "@vueform/multiselect";
import ApiService from "@/services/ApiService";
import { useRoute, useRouter } from "vue-router";
import { success, error, getUrlApiForFiles } from "@/utils/utils";

export default defineComponent({
    name: "EditPublication",
    components: { Form, Field, ErrorMessage, Multiselect },

  setup() {
    const route = useRoute();
    const router = useRouter();
    const id = route.params.id;
    const loaded = ref(false);
    const initialValues = ref<any>({});
    const currentImage = ref<string | null>(null);
    const imageFile = ref<File | null>(null);

    const categorieOptions = [
      "Mémoire",
      "Textes",
      "Publication enseignant"
    ];

    const publicationSchema = Yup.object({
      titre: Yup.string().required(),
      auteur: Yup.string().required(),
      categoriepublication: Yup.string().required(),
      annepublication: Yup.number().required(),
      editeur: Yup.string().required(),
      contenu: Yup.string().nullable(),
    });

    const onImageChange = (e: Event) => {
      const files = (e.target as HTMLInputElement).files;
      if (files && files.length) imageFile.value = files[0];
    };

    const loadPublication = async () => {
      try {
        const { data } = await ApiService.get(`/publications/${id}`);
        initialValues.value = data.data;
        currentImage.value = data.data.urlImage;
        contenu.value = data.data.contenu ?? "";
        loaded.value = true;
      } catch {
        error("Impossible de charger la publication");
      }
    };

    const contenu = ref("");
    const contenuEditor = ref();
    const empty = ref("<p><br></p>")
    const showA = ref(false)
    const show = ref("0")
    const onSubmit = () => {
      if(contenuEditor.value.getHTML() !== empty.value) {
        showA.value = false;
        console.log('hijgrgrkjgmerjm')
      }
      else if(contenuEditor.value.getHTML() === empty.value) {
        showA.value = true;
        show.value = "1"
      }
    }
   const updatePublication = async (values: any) => {
  try {
    const formData = new FormData();

    Object.keys(values).forEach(key => {
      if (key !== "contenu") {
        formData.append(key, values[key] ?? "");
      }
    });

    // 
    formData.append("contenu", contenuEditor.value.getHTML());

    if (imageFile.value) {
      formData.append("urlImage", imageFile.value);
    }

    await ApiService.put(`/publications/${id}`, formData);

    success("Publication modifiée avec succès");
    router.push("/listPublication");
  } catch (e) {
    console.error(e);
    error("Erreur lors de la modification");
  }
};


    onMounted(loadPublication);

    return {
      onSubmit,
      contenu,
      contenuEditor,
      publicationSchema,
      categorieOptions,
      initialValues,
      loaded,
      updatePublication,
      onImageChange,
      currentImage,
      getUrlApiForFiles
    };
  }
});
</script>
